import { ChangeDetectorRef, EventEmitter, OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { AppStateFacade, Theme, } from '@app-state';
import { hasSupportForPrefersColorScheme } from '@uipath/angular/utilities';
import UiValidators, { UI_EMAIL_MAX_LENGTH, UI_NAME_MAX_LENGTH, } from '@validators';
import { Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var UiUserProfileGeneralComponent = /** @class */ (function () {
    function UiUserProfileGeneralComponent(_appState, _fb, _cd) {
        this._appState = _appState;
        this._fb = _fb;
        this._cd = _cd;
        this.submitUser = new EventEmitter();
        this.enterViewMode = new EventEmitter();
        this.hasSupportForPrefersColorScheme = hasSupportForPrefersColorScheme();
        this.disallowEmailChange = true;
        this.autoTheme = Theme.auto;
        this._user = {};
        this._destroyed$ = new Subject();
        this.disallowEmailChange = !this._appState.authConfig.value.cloud.allowSelfEmailUpdate;
        this.theme$ = this._appState.user.theme.value$;
    }
    Object.defineProperty(UiUserProfileGeneralComponent.prototype, "user", {
        get: function () {
            return this._user;
        },
        set: function (_a) {
            var name = _a.name, surname = _a.surname, emailAddress = _a.emailAddress, userName = _a.userName, tenantDisplayName = _a.tenantDisplayName;
            this._user = {
                name: name,
                surname: surname,
                emailAddress: emailAddress,
                userName: userName,
                tenantDisplayName: tenantDisplayName,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiUserProfileGeneralComponent.prototype, "themes", {
        get: function () {
            return Object.keys(Theme).filter(function (theme) { return theme !== Theme.auto; });
        },
        enumerable: true,
        configurable: true
    });
    UiUserProfileGeneralComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this._fb.group({
            'name': [
                this.user.name,
                Validators.maxLength(UI_NAME_MAX_LENGTH),
            ],
            'surname': [
                this.user.surname,
                Validators.maxLength(UI_NAME_MAX_LENGTH),
            ],
            'emailAddress': [
                this.user.emailAddress || '',
                Validators.compose([
                    Validators.maxLength(UI_EMAIL_MAX_LENGTH),
                    UiValidators.email(true),
                ])
            ],
        });
        this.formGroup
            .valueChanges
            .pipe(takeUntil(this._destroyed$)).subscribe(function (value) {
            Object.assign(_this._user, value);
        });
    };
    UiUserProfileGeneralComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
    };
    UiUserProfileGeneralComponent.prototype.viewMode = function (emit) {
        if (emit === void 0) { emit = true; }
        this.edit = false;
        if (emit && this.formGroup.dirty) {
            this.enterViewMode.emit();
        }
        this._cd.markForCheck();
    };
    UiUserProfileGeneralComponent.prototype.editMode = function () {
        this.edit = true;
        this._cd.markForCheck();
    };
    UiUserProfileGeneralComponent.prototype.changeTheme = function (theme) {
        this._appState.user.theme.set(theme);
    };
    return UiUserProfileGeneralComponent;
}());
export { UiUserProfileGeneralComponent };
